module.exports = __webpack_public_path__ + "img/1723615123207-WhatsApp Image 2024-08-14 at 13.45.28 1.jpeg.3cff0692.webp";